// src/lib/dashboard/departamentoComercial.ts
import type { Profile } from '../../../types';
import { getChannel } from '../canalComercial.ts';
import { ehLicitacao } from '../origensNegociacao.ts';

// Departamento comercial do Painel Executivo — mais granular que o Canal já
// usado no Analytics Comercial (canalComercial.ts::getChannel), que
// DELIBERADAMENTE não mexemos: telas existentes (Analytics Comercial,
// Performance Dashboard) iteram sobre os 3 canais fixos de CHANNELS —
// introduzir uma 4ª categoria ali faria negociações de empresa parceira
// desaparecerem silenciosamente das tabelas por canal dessas duas telas.
// Até 29/10/2026 o Comercial se dividia em 'interno' e 'externo'. Virou um canal
// só, 'comercial' (#6520): Closer, BDR e Hunter são funções dentro dele.
export type DepartamentoComercial = 'todos' | 'comercial' | 'parceiros' | 'empresa_parceira' | 'licitacao';

// Limitação conhecida e aceita: só identifica corretamente "Empresa Parceira"
// quando o responsável está cadastrado como empresa_parceira_admin/operador
// (ou tem empresa_parceira_id preenchido). Hoje o único caso real de
// negociação de empresa parceira (ASSOCIACAO ENERGIA GO, respons. Pedro
// Teixeira) está cadastrado como role 'parceiro' — cai em 'parceiros' até o
// cadastro ser corrigido, o que é esperado, não é bug do painel.
/**
 * O canal de uma NEGOCIAÇÃO.
 *
 * Licitação vem da própria negociação (`origem = 'Licitação'`), não do perfil de
 * quem responde por ela: venda pública costuma nascer sem responsável comercial,
 * e sem esta regra ela caía em "Venda Externa" pelo padrão de
 * `getDepartamentoComercial(undefined)`. Foi o caso da Prefeitura de Morrinhos
 * em SET/2026: 151.928 kWh, 99,7% do kWh do card "Termo aprovado" de um canal
 * onde nenhum vendedor externo trabalhou.
 *
 * Os outros quatro canais continuam saindo do responsável — quem vende por
 * licitação é a empresa, não um departamento novo de vendedores.
 */
export function canalDaNegociacao(
  negociacao: { origem?: string | null; responsavel_id?: string | null },
  profilesById: ReadonlyMap<string, Profile>,
): DepartamentoComercial {
  if (ehLicitacao(negociacao.origem)) return 'licitacao';
  const perfil = negociacao.responsavel_id ? profilesById.get(String(negociacao.responsavel_id)) : undefined;
  return getDepartamentoComercial(perfil);
}

export function getDepartamentoComercial(p: Profile | undefined): DepartamentoComercial {
  if (!p) return 'comercial';
  if (p.role === 'empresa_parceira_admin' || p.role === 'empresa_parceira_operador' || p.empresa_parceira_id) return 'empresa_parceira';
  if (getChannel(p) === 'Parceiros') return 'parceiros';
  return 'comercial';
}
